// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2S35J","inputDescription":"styles_inputDescription__3Dt1e"};